import { AbstractControl, ValidatorFn } from '@angular/forms';
import { DateInputModel, InputValidationErrors } from '@libs/form/models';
import { DateTime } from 'luxon';

export class DateFilterValidator {
  public static validateFn(item: DateInputModel): ValidatorFn {
    return (control: AbstractControl): InputValidationErrors | null => this.validate(control, item);
  }

  private static validate(control: AbstractControl, item: DateInputModel): InputValidationErrors | null {
    if (!control.value || !item.filter) {
      return null;
    }

    if (item.filter && !item.filter(control.value as DateTime)) {
      return {
        dateFilter: true,
      };
    }

    return null;
  }
}
